import React from 'react';
import IntroPisoSpc from '../components/sections/Piso-Spc/IntroPisoSpc';
import TituloPisoSpc from '../components/sections/Piso-Spc/TituloPisoSpc';
import TituloRecubrimientoMuros from '../components/sections/RecubrimientosMuros/TituloRecubrimientoMuro';
import IntroMuros from '../components/sections/RecubrimientosMuros/IntroMuros'; 
import CatalogoMuros from '../components/sections/RecubrimientosMuros/CatalogoMuros';
import FormularioMuros from '../components/sections/RecubrimientosMuros/FormularioMuros';  
import Header from '../components/layouts/Header';
import Footer from '../components/layouts/Footer';

const RecubrimientosMuros = () => {
  return (
    <div>
      <Header />
       {/* Sección introductoria del piso vinílico LVT */}
       <TituloRecubrimientoMuros />
       <CatalogoMuros /> 
       <IntroMuros />   
       <FormularioMuros/>  

      <Footer />
    </div>
  );
};

export default RecubrimientosMuros;